import React, { Component } from 'react'
import { Button, Container, Row, Col, Form, Table, Navbar } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { AdminNav, Loading } from '../../helpers'
import TextInput from 'react-autocomplete-input';
import Calendar from 'react-calendar'
import "react-datepicker/dist/react-datepicker.css";
import '../datepicker.css'
import axios from 'axios'
import Modal from 'react-bootstrap/Modal';

class FinancialWageSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Rice: {},
      target: '',
      targetObj: '',
      isModalShow: false,
      savingText: false,
      isLoading: true,
      newCompanyTaxData: {},
      riceData: [],
      c: '',
      modalData: {
        'modalObjectName': '',
        'modalObjectIdx': '',
        'surveyNameEN': '',
        'surveyNameTH': ''
      }
    }
    this.handleChangeCompanyTaxID = this.handleChangeCompanyTaxID.bind(this)
    this.saveData = this.saveData.bind(this)
    this.handleModal = this.handleModal.bind(this)
    this.addNewCompany = this.addNewCompany.bind(this)
  }

  componentDidMount() {
    let viewAllCompany = axios.get(
      'https://backend1.riceinspections.com/testD'
    )
    let viewSurvey = fetch(`https://backend1.riceinspections.com/testBD`).then((res) => {
      return res.json()
    })
    Promise.all([viewAllCompany, viewSurvey]).then((data) => {
      console.log(data)
      let companyData = data[0]['data']
      this.setState({
        ...this.state,
        riceData: data[1],
        isLoading: false,
      })
    })
    // setInterval(()=>{
    //   this.setState({
    //     ...this.state,
    //     savingText : !this.state.savingText
    //   })
    // },15000)
  }
  saveData(data, newCompanyTaxData) {
    let reConstructData = {}
    Object.keys(data).map((key, idx) => {
      let taxArrayFinal = []
      if (newCompanyTaxData[idx]) {
        let newCompanyTaxArray = {}
        console.log(newCompanyTaxData[idx])
        if (!data[key]['companyTaxID']) {
          newCompanyTaxArray = Object.values({
            '0': {
              'companyTax': newCompanyTaxData[idx][0]['companyTax'],
              'fare': newCompanyTaxData[idx][0]['fare'] ?? '0'
            }
          })
        } else {
          let companyTaxArray = Object.keys(data[key]['companyTaxID'])
          let newCompanyIndex = Object.keys(newCompanyTaxData[idx])


          newCompanyTaxArray = {}

          companyTaxArray.map((str) => {
            if (newCompanyTaxData[idx][str]) {
              newCompanyTaxArray = {
                ...newCompanyTaxArray,
                [str]: {
                  ...newCompanyTaxArray[str],
                  'companyTax': newCompanyTaxData[idx][str]['companyTax'] ?? data[key]['companyTaxID'][str]['companyTax'],
                  'fare': newCompanyTaxData[idx][str]['fare'] ?? '0'
                }
              }
            } else {
              newCompanyTaxArray = {
                ...newCompanyTaxArray,
                [str]: {
                  ...data[key]['companyTaxID'][str],
                }
              }
            }
          })

          if(parseInt(newCompanyIndex[0]) > parseInt(companyTaxArray[companyTaxArray.length-1])){
            let str = parseInt(newCompanyIndex[0])
            newCompanyTaxArray = {
              ...newCompanyTaxArray,
              [parseInt(newCompanyIndex[0])] : {
                'companyTax': newCompanyTaxData[idx][str]['companyTax'],
                'fare' : newCompanyTaxData[idx][str]['fare'] ?? '0'
              }
            }
          }


        }
        console.log(newCompanyTaxArray)
        reConstructData[key] = {
          ...data[key],
          companyTaxID: Object.values(newCompanyTaxArray)
        }
      } else {
        reConstructData[key] = {
          ...data[key],
        }
      }
    })
    console.log(reConstructData)
    let newReconstrcutData = {}
    let c = axios.post(
      'https://backend1.riceinspections.com/testGA',
      { data: reConstructData }
    )
      .then((res) => {
        alert('บันทึกเรียบร้อยแล้ว')

        let viewAllCompany = axios.get(
          'https://backend1.riceinspections.com/testD'
        )
        let viewSurvey = fetch(`https://backend1.riceinspections.com/testBD`).then((res) => {
          return res.json()
        })
        Promise.all([viewAllCompany, viewSurvey]).then((data) => {
          let companyData = data[0]['data']
          this.setState({
            ...this.state,
            riceData: data[1],
            isLoading: false,
          })
        })

      }).catch((err) => {
        alert('เกิดข้อผิดพลาด')
      })
  }
  changeShape(data, newCompanyTaxData) {
    let reConstructData = {}
    Object.keys(data).map((key, idx) => {
      let taxArrayFinal = []
      let companyTaxArray = data[key]['companyTaxID']
      let isObjectBeArray = Array.isArray(companyTaxArray)
      let isObjectHas = data[key]['companyTaxID']

      if (isObjectHas) {

        let newCompanyTaxArray = {}


        Object.keys(companyTaxArray).map((str, idx) => {
          if (`${str}`.length == 13) {
            newCompanyTaxArray = {
              ...newCompanyTaxArray,
              [idx]: {
                ...newCompanyTaxArray[str],
                'companyTax': str,
                'fare': '0'
              }
            }
          }
        })

        reConstructData[key] = {
          ...data[key],
          'companyTaxID': newCompanyTaxArray
        }
      }
      // if (newCompanyTaxData[idx]) {
      //   console.log('loop')
      //   let taxArrayStr = `${newCompanyTaxData[idx]}`
      //   let taxArray = taxArrayStr.split(',')
      //   taxArray.map((str) => {
      //     if (str.length == 13) {
      //       taxArrayFinal.push(str)
      //     }
      //   })
      //   reConstructData[key] = {
      //     ...data[key],
      //     companyTaxID: taxArrayFinal
      //   }
      // } else {
      //   reConstructData[key] = {
      //     ...data[key],
      //   }
      // }


    })
    // console.log(reConstructData)
    let newReconstrcutData = {}
    // let c = axios.post(
    //   'https://backend1.riceinspections.com/testGA',
    //   { data: reConstructData }
    // )
    //   .then((res) => {
    //     alert('บันทึกเรียบร้อยแล้ว')
    //   }).catch((err) => {
    //     alert('เกิดข้อผิดพลาด')
    //   })
  }

  handleChangeRiceNameToRiceType(e, objName, fieldName) {
    this.setState({
      ...this.state,
      riceData: {
        ...this.state.riceData,
        [objName]: {
          ...this.state.riceData[objName],
          [fieldName]: e
        }
      }
    })
  }

  handleChangeCompanyTaxID(e, idx, title, fieldName) {
    console.log(e.target.value, idx, title, fieldName)
    if (e.target.value) {
      let rawState = this.state.newCompanyTaxData[idx]

      let obj = {
        [title]: {
          [fieldName]: e.target.value
        }
      }
      if (rawState) {
        obj = {
          ...rawState,
          [title]: {
            ...rawState[title],
            [fieldName]: e.target.value
          }
        }
      }

      this.state.newCompanyTaxData = {
        ...this.state.newCompanyTaxData,
        [idx]: obj
      }
      console.log(this.state.newCompanyTaxData)
    }
  }
  renderAddButton(idx, totalLength, a,surveyNameTH,surveyNameEN) {

    let isLast = (parseInt(totalLength) - 1 - parseInt(idx)) == 0 ? true : false
    // console.log(idx,totalLength,a,isLast)
    if (isLast) {
      return <svg
        id='open'
        onClick={(e) => {
          console.log(idx)
          this.handleModal(e, {
            objName: a,
            pos: idx,
            idx: 0,
            surveyNameTH: surveyNameTH,
            surveyNameEN: surveyNameEN,
          })
        }}

        xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-lg" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" />
      </svg>

    }
  }
  renderRiceType(riceData) {
    if (riceData) {
      return (
        Object.keys(riceData).map((a, idx) => {
          // console.log(a)
          if (riceData[a]['companyTaxID']) {
            let totalLength = Object.keys(riceData[a]['companyTaxID']).length
            return (Object.keys(riceData[a]['companyTaxID']).map((companyTaxID, idz) => {
              return <tr>
                <td>
                  <Form.Group as={Col}>
                    <TextInput Component='input'
                      regex={''} spacer={''} maxOptions={10}
                      value={riceData[a]['surveyNameTH']}
                      onChange={(e) => { this.handleChangeRiceNameToRiceType(e, a, 'surveyNameTH') }}
                      className='form-control' trigger={''} />
                  </Form.Group>
                </td>
                <td>
                  <Form.Group as={Col}>
                    <TextInput Component='input'
                      regex={''} spacer={''} maxOptions={10}
                      value={riceData[a]['surveyNameEN']}
                      onChange={(e) => { this.handleChangeRiceNameToRiceType(e, a, 'surveyNameEN') }}
                      className='form-control' trigger={''} />
                  </Form.Group>
                </td>
                <td>
                  <Form.Group as={Col}>
                    <input Component='input'

                      regex={''} spacer={''} maxOptions={10}
                      defaultValue={riceData[a]['companyTaxID'][companyTaxID]['fare']}
                      onChange={(e) => { this.handleChangeCompanyTaxID(e, idx, idz, 'fare') }}
                      className='form-control' trigger={''} />
                  </Form.Group>
                </td>
                <td>
                  <Form.Group as={Col}>
                    <input Component='input'
                      regex={''} spacer={''} maxOptions={10}
                      defaultValue={riceData[a]['companyTaxID'][companyTaxID]['companyTax']}
                      onChange={(e) => { this.handleChangeCompanyTaxID(e, idx, idz, 'companyTax') }}
                      className='form-control' trigger={''} />
                  </Form.Group>
                </td>
                <td>

                  {
                    this.renderAddButton(idz, totalLength, a,riceData[a]['surveyNameTH'],riceData[a]['surveyNameEN'])
                  }


                </td>
              </tr>
            }))
          } else {
            return <tr>
              <td>
                <Form.Group as={Col}>
                  <TextInput Component='input'
                    regex={''} spacer={''} maxOptions={10}
                    value={riceData[a]['surveyNameTH']}
                    onChange={(e) => { this.handleChangeRiceNameToRiceType(e, a, 'surveyNameTH') }}
                    className='form-control' trigger={''} />
                </Form.Group>
              </td>
              <td>
                <Form.Group as={Col}>
                  <TextInput Component='input'
                    regex={''} spacer={''} maxOptions={10}
                    value={riceData[a]['surveyNameEN']}
                    onChange={(e) => { this.handleChangeRiceNameToRiceType(e, a, 'surveyNameEN') }}
                    className='form-control' trigger={''} />
                </Form.Group>
              </td>
              <td>
                <Form.Group as={Col}>
                  <input Component='input'
                    regex={''} spacer={''} maxOptions={10}
                    defaultValue={riceData[a]['fare']}
                    onChange={(e) => { this.handleChangeCompanyTaxID(e, idx, 0, 'fare') }}
                    className='form-control' trigger={''} />
                </Form.Group>
              </td>
              <td>
                <Form.Group as={Col}>
                  <input Component='input'
                    regex={''} spacer={''} maxOptions={10}
                    defaultValue={riceData[a]['companyTaxID']}
                    onChange={(e) => { this.handleChangeCompanyTaxID(e, idx, 0, 'companyTax') }}
                    className='form-control' trigger={''} />
                </Form.Group>
              </td>
              <td>
                {/* <svg
                  id='open'
                  // onClick={(e) => {
                  //   this.handleModal(e, {
                  //     objName: a,
                  //     pos: idx,
                  //     idx: 0,
                  //     surveyNameTH: riceData[a]['surveyNameTH'],
                  //     surveyNameEN: riceData[a]['surveyNameEN'],
                  //   })
                  // }}
                  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-lg" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" />
                </svg> */}
              </td>
            </tr>
          }

        })
      )
    }
  }
  showSaving() {
    if (this.state.savingText) {
      return 'Saving...'
    } else {
      return 'Saved 1 min ago.'
    }
  }
  goFinancialWageCalendar = () => {
    this.props.history.push({
      pathname: '/FinancialWageCalendar',
    })
  }
  handleModal(e = null, option = {}) {
    // console.log(e)
    if (!e) {
      this.setState({
        ...this.state,
        isModalShow: false
      })
      return
    }
    if (e.target.id == 'open') {
      console.log(option)
      console.log(this.state.riceData)
      let order = Object.keys(this.state.riceData).indexOf(option['objName'])
      console.log(order)


      this.setState({
        ...this.state,
        isModalShow: true,
        modalData: {
          'modalObjectName': option['objName'],
          'modalObjectPos': order,
          'modalObjectIdx': parseInt(option['pos']) + 1,
          'surveyNameEN': option['surveyNameEN'],
          'surveyNameTH': option['surveyNameTH']
        }
      })
    } else {
      this.setState({
        ...this.state,
        isModalShow: false
      })
    }
  }
  addNewCompany() {
    console.log(this.state.newCompanyTaxData)
  }
  render() {
    if (this.state.isLoading) {
      return (<Container>
        <AdminNav></AdminNav>
        <br></br>
        <Loading></Loading>

      </Container>)

    } else {
      return (
        <Container>
          <AdminNav></AdminNav>
          <Navbar style={{ backgroundColor: '#F5F5F5' }} sticky="top" >
            <Container>
              <Button onClick={() => { this.goFinancialWageCalendar() }}> กลับไปยังหน้าค่าแรง </Button>
              <Navbar.Brand href="#">{
                // this.showSaving()
              } </Navbar.Brand>
              <Button onClick={() => { this.saveData(this.state.riceData, this.state.newCompanyTaxData) }}> save </Button>
            </Container>
          </Navbar>

          <Table bordered hover>
            <thead>
              {<tr><th>ชื่อสถานที่ภาษาไทย</th><th>ชื่อสถานที่ภาษาอังกฤษ</th><th>ค่าพาหนะ (บาท) </th><th>เลขเสียภาษี</th></tr>}
            </thead>
            <tbody>
              {this.renderRiceType(this.state.riceData)}
            </tbody>
          </Table>

          <Modal
            size="lg"

            show={this.state.isModalShow} onHide={this.handleModal}>
            <Modal.Header closeButton>
              <Modal.Title>เพิ่มบริษัทและค่าพาหนะ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <tr><th>ชื่อสถานที่ภาษาไทย</th><th>ชื่อสถานที่ภาษาอังกฤษ</th><th>ค่าพาหนะ (บาท) </th><th>เลขเสียภาษี</th></tr>
              <tr>
                <td>
                  <Form.Group as={Col}>
                    <input Component='input'
                      regex={''} spacer={''} maxOptions={10}
                      value={this.state.modalData['surveyNameTH']} disabled
                      className='form-control' trigger={''} />
                  </Form.Group>
                </td>
                <td>
                  <Form.Group as={Col}>
                    <input Component='input'
                      regex={''} spacer={''} maxOptions={10}
                      value={this.state.modalData['surveyNameEN']} disabled
                      className='form-control' trigger={''} />
                  </Form.Group>
                </td>
                <td>
                  <Form.Group as={Col}>
                    <input Component='input'
                      regex={''} spacer={''} maxOptions={10}
                      defaultValue={0}
                      onChange={(e) => { this.handleChangeCompanyTaxID(e, this.state.modalData['modalObjectPos'], this.state.modalData['modalObjectIdx'], 'fare') }}
                      className='form-control' trigger={''} />
                  </Form.Group>
                </td>
                <td>
                  <Form.Group as={Col}>
                    <input Component='input'
                      regex={''} spacer={''} maxOptions={10}
                      defaultValue={0}
                      onChange={(e) => { this.handleChangeCompanyTaxID(e, this.state.modalData['modalObjectPos'], this.state.modalData['modalObjectIdx'], 'companyTax') }}
                      className='form-control' trigger={''} />
                  </Form.Group>
                </td>
              </tr>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleModal}>
                ปิด
          </Button>
              <Button variant="primary" onClick={()=>{this.saveData(this.state.riceData, this.state.newCompanyTaxData)}}>
                บันทึก
          </Button>
            </Modal.Footer>
          </Modal>

        </Container>
      );
    }

  }
}
export default withRouter(FinancialWageSetting)
